import { render, staticRenderFns } from "./MobileAppSettingsCard.vue?vue&type=template&id=e89337a8&"
import script from "./MobileAppSettingsCard.vue?vue&type=script&lang=js&"
export * from "./MobileAppSettingsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports